import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';
import { UseQueryOptions } from 'react-query';
import useQuery from '../useQuery';
import QueryKeys from './keys';

// Type for a single audit entry
export type CampaignAuditEntry = {
    campaign_id: string;
    send_id: string | null;
    created_at: string;
    created_by_user_id: string;
    created_by_email: string;
    action: string;
    old_value: string | null;
    new_value: string | null;
    old_id: string | null;
    new_id: string | null;
};

// Type for the API response - object with datetime keys and arrays of audit entries as values
export type CampaignAuditResponse = Record<string, CampaignAuditEntry[]>;

const useCampaignAudit = (campaignId: string, reactQueryOptions?: UseQueryOptions<CampaignAuditResponse, Error>) =>
    useQuery<CampaignAuditResponse>(
        QueryKeys.CAMPAIGN_AUDIT(campaignId),
        new PathWithID(CuredApiPaths.CAMPAIGNS_AUDIT, campaignId),
        {
            enabled: !!campaignId,
            ...reactQueryOptions,
        }
    );

export default useCampaignAudit;
